import { default as React } from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  skeleton: {
    display: 'block',
    backgroundColor: theme.palette.action.hover,
    borderRadius: theme.shape.borderRadius,
    animation: '$pulse 1.5s ease-in-out 0.5s infinite',
  },
  '@keyframes pulse': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.5 },
    '100%': { opacity: 1 },
  },
}));

type SkeletonBlockProps = {
  width?: string | number;
  height?: string | number;
  className?: string;
};

export const SkeletonBlock: React.FC<SkeletonBlockProps> = ({
  width = '100%',
  height = 24,
  className,
}) => {
  const classes = useStyles();
  return (
    <div
      className={className ? `${classes.skeleton} ${className}` : classes.skeleton}
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
      }}
    />
  );
};
